
import React, { useContext } from 'react';
import Drag from './Drag';
import { AppContext } from '../../context/app.context';
import { IonItem, IonLabel, IonIcon } from '@ionic/react';
import { createCustomItems } from '../../misc/utils';

const CustomDrag = React.memo((props: {}) => {
    const { questionnaire } = useContext(AppContext);
    const customItems = createCustomItems();

    return (
        <div className="drag-drop-container">
            {
                customItems.filter(f => (questionnaire.SearchedText && f.Label) ?  f.Label.toLowerCase().indexOf(questionnaire.SearchedText) > -1 : 1)
                .sort((a, b) => a.Label!.localeCompare(b.Label!))
                .map((item, index) => (
                    <Drag key={index} type="custom" dataItem={item} dragImage="" dropEffect="link">
                        <IonItem className="pointer">
                            <IonLabel>
                                {item.Label} <IonIcon icon={item.Icon} />
                            </IonLabel>
                        </IonItem>
                    </Drag>
                ))}
        </div>
    )
});

export default CustomDrag;